<script>
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import validateZhTw from 'vee-validate/dist/locale/zh_TW'
import { merchantComputed, authComputed, authMethods } from '@state/helpers'

Vue.use(VeeValidate, { events: 'input|blur' });
Validator.localize('zh_TW', validateZhTw);

export default {
  data() {
    return {
      defaultAvatar: require('@assets/images/avatar_default.jpg'),
      storeProcessing: false,
      formData: {
        phoneNumber: '',
        phoneCode: '',
        fullName: '',
        gender: 'male',
        email: '',
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    isFormValid() {
      return Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
  },
  mounted() {
    this.formData = {
      fullName: this.currentMember.fullName,
      gender: this.currentMember.gender || 'male',
      email: this.currentMember.email,
      phoneNumber: this.currentMember.phone.split('-')[1],
      phoneCode: this.currentMember.phone.split('-')[0],
    };
  },
  methods: {
    ...authMethods,
    onClose() {
      this.$emit('close')
    },
    handleSave() {
      this.storeProcessing = true;

      this.storeMember(this.formData)
        .then(() => {
          this.$toast.open('儲存成功');
          this.onClose();
        })
        .finally(() => (this.storeProcessing = false));
    }
  },

}
</script>
<template>
  <div :class="$style['modalWrapper']" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{$t('global.EDIT_INFORMATION' /*編輯個人資訊*/)}}</p>
      <div :class="$style['modalClose']" class="delete" @click="onClose"></div>
    </header>
    <div>
      <section class="modal-card-body">
        <div style="text-align: center;margin: 1rem 0">
          <picture :class="$style['avatar']">
            <BaseImage :src="defaultAvatar" :error-src="defaultAvatar" class-name="is-cover" />
          </picture>
        </div>
        <form @submit.prevent="handleSave">
          <!--<b-field
            :label="$t('global.PHONE', /* 電話 */)"
            expanded
          >
            <b-field
              :class="$style['fieldNested']"
              :type="{ 'is-danger': errors.has('phoneNumber') }"
              :message="errors.first('phoneNumber') ? $t('global.VERIFICATION_PHONE'/* 請輸入正確的手機號碼格式, 09XXXXXXXX */) : ''"
            >
              <div class="control">
                <b-button
                  outlined
                  rounded
                  class="is-select-style"
                  disabled
                >{{ formData.phoneCode }}</b-button>
              </div>
              <b-input
                v-model="formData.phoneNumber"
                v-validate="formData.phoneCode === '+886' ? 'required|digits:10|regex:^09' : ''"
                :data-vv-as="$t('global.PHONE', /* 電話 */)"
                name="phoneNumber"
                placeholder="ex: 0912345678"
                type="tel"
                disabled
                rounded
                expanded
              ></b-input>
            </b-field>
          </b-field>-->
          <!--<b-field
            :label="$t('global.NAME', /* 姓名 */)"
            :class="$style['isRequired']"
            expanded
          >
            <b-field
              :class="$style['fieldNested']"
              :type="{ 'is-danger': errors.has('fullName') }"
              :message="errors.first('fullName')"
            >
              <b-input
                v-model="formData.fullName"
                v-validate="'required'"
                :data-vv-as="$t('global.NAME', /* 姓名 */)"
                name="fullName"
                placeholder="ex: 余春嬌"
                rounded
                expanded
              ></b-input>
              <b-select
                v-model="formData.gender"
                rounded
                class="has-radius-danger"
                :placeholder="$t('global.GENDER'/* 稱呼 */)"
              >
                <option value="female">{{ $t('global.FEMALE'/* 小姐 */) }}</option>
                <option value="male">{{ $t('global.MALE'/* 先生 */) }}</option>
              </b-select>
            </b-field>
          </b-field>-->
          <!--<b-field
            :message="errors.first('fullName')"
            :type="{ 'is-danger': errors.has('fullName') }"
            :label="$t('global.NAME', /* 姓名 */)"
            :class="$style['isRequired']"
          >
            <b-input
              v-model="formData.fullName"
              v-validate="'required'"
              :data-vv-as="$t('global.NAME', /* 姓名 */)"
              name="fullName"
              placeholder="ex: 余春嬌"
              rounded
              expanded
            ></b-input>
          </b-field>
          <b-field
            :label="$t('global.GENDER'/* 稱呼 */)"
            :class="$style['isRequired']"
            expanded
          >
            <b-field
              :message="errors.first('gender')"
              :class="$style['fieldNested']"
              :type="{ 'is-danger': errors.has('gender') }"
            >
              <b-radio
                v-validate="'required'"
                v-model="formData.gender"
                name="gender"
                native-value="male"
              >
                先生
              </b-radio>
              <b-radio
                v-validate="'required'"
                v-model="formData.gender"
                name="gender"
                native-value="female"
              >
                小姐
              </b-radio>
            </b-field>
          </b-field>-->
          <b-field grouped style="margin-bottom: 0">
            <b-field
              :message="errors.first('fullName')"
              :type="{ 'is-danger': errors.has('fullName') }"
              :label="$t('global.NAME', /* 姓名 */)"
              :class="$style['isRequired']"
              expanded
            >
              <b-input
                v-model="formData.fullName"
                v-validate="'required'"
                :data-vv-as="$t('global.NAME', /* 姓名 */)"
                name="fullName"
                placeholder="ex: 余春嬌"
                rounded
                expanded
              ></b-input>
            </b-field>
            <b-field :class="$style['fieldGender']">
              <b-field
                :message="errors.first('gender')"
                :class="$style['fieldNested']"
                :type="{ 'is-danger': errors.has('gender') }"
              >
                <b-radio
                  v-validate="'required'"
                  v-model="formData.gender"
                  name="gender"
                  native-value="male"
                >
                  先生
                </b-radio>
                <b-radio
                  v-validate="'required'"
                  v-model="formData.gender"
                  name="gender"
                  native-value="female"
                >
                  小姐
                </b-radio>
              </b-field>
            </b-field>
          </b-field>
          <b-field
            :message="errors.first('email')"
            :type="{ 'is-danger': errors.has('email') }"
            :label="'Email'"
            :class="$style['isRequired']"
          >
            <b-input
              v-model="formData.email"
              v-validate="'required|email'"
              :data-vv-as="'Email'"
              name="email"
              type="email"
              placeholder="ex: you@mail.com"
              rounded
              expanded
            ></b-input>
          </b-field>
          <br>
          <div class="buttons">
            <b-button
              type="is-primary"
              class="is-fullwidth"
              :loading="storeProcessing"
              :disabled="isFormValid"
              rounded
              @click="handleSave"
            >{{ $t('global.MEMBER_SETTING_SAVE'/* 儲存修改 */) }}</b-button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>
<style lang="scss" module>
  .title {
    @extend %typography-medium;
    margin-bottom: 1rem;
    color: $color-primary;
    font-weight: 500;
    text-transform: capitalize;
  }

  .titleBox {
    margin-bottom: 5rem;
  }

  .fieldGender {
    padding-top: 2.5rem;
  }

  .fieldNested {
    flex-wrap: wrap;
    :global(.help) {
      width: 100%;
    }
    :global(.is-expanded) {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }

  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }

  .modalWrapper {
    display: flex;
    flex-direction: column;
    border-radius: $size-section-border-radius;
    background: white;
    overflow: hidden;
  }

  .modalClose {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }

    &:before,
    &:after {
      background-color: $grey;
    }

    &:after {
      height: 100%;
    }

    &:before {
      width: 100%;
    }
  }

  .avatar {
    position: relative;
    box-sizing: content-box;
    width: 100px;
    height: 100px;
    overflow: hidden;
    cursor: pointer;
    background: #dbdbdb;
    border-radius: 100%;
    display: inline-block;
    img {
      max-height: unset;
    }
  }
</style>
